<div class="auth">
  <header class="auth-header">
    <img src="assets/images/logo.png" alt="SipSignal Efax Logo" class="auth-header-logo" />
  </header>

  <main class="auth-main">
    <h1 class="h2">Login</h1>

    <form [formGroup]="form" class="auth-form" (ngSubmit)="authorize()">
      <input formControlName="email" type="text" placeholder="E-mail or Login" class="form-input_lg" />

      <div class="form-input-wrapper">
        <input
          formControlName="password"
          [type]="isPasswordVisible ? 'text' : 'password'"
          placeholder="Password"
          class="form-input_lg"
        />

        <button type="button" class="form-input-button">
          <img
            [src]="isPasswordVisible ? 'assets/icons/eye.svg' : 'assets/icons/eye-off.svg'"
            alt="Toggle password visibility"
            class="form-input-icon"
            (click)="togglePasswordVisibility()"
          />
        </button>
      </div>

      <a routerLink="/auth/restore-password" class="link">Forgot your password?</a>

      <div class="auth-form-actions">
        <button type="submit" [disabled]="form.invalid" class="btn_primary btn_lg auth-form-submit-button">
          Login
        </button>

        <a routerLink="/auth/sign-up" class="btn_text btn_lg auth-form-sign-up-link">Sign up</a>
      </div>

      <p *ngIf="isAuthError" class="form-error">Incorrect login or password</p>
    </form>
  </main>
</div>
